import React from 'react';
import './style.scss';
import { bool, any } from 'prop-types';

const Loading = ({ children, isLoading, overlayOnChildren }) => {
   return (
      <>
         <div className="loading-wrapper">
            {isLoading && !overlayOnChildren && (
               <div className="loading-wrapper-main">
                  <div className="loading-wrapper-content">
                  <img src="/images/loading.svg" alt="loading" />
                  </div>
               </div>
            )}  
            <div className={`loading-fade-in ${isLoading && overlayOnChildren ? 'loading-overlay-container' : ''}`}>
               { (overlayOnChildren || !isLoading) && children}
               {isLoading && overlayOnChildren && <div className="loading-overlay-animator" />}
            </div>
         </div>
      </>
   );
};

Loading.propTypes = {
   children: any,
   isLoading: bool,
   overlayOnChildren: bool,
};

export default Loading;
